import script from "./WNewPassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./WNewPassword.vue?vue&type=script&setup=true&lang=ts"

import "./WNewPassword.vue?vue&type=style&index=0&id=a9bcbb3a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9bcbb3a"]])

export default __exports__